import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { Mode, TableActionType } from 'src/types/crudTable';
import { getCellValue, getInitTableData } from '../utils';
export function tableReducer(state, action) {
  switch (action.type) {
    case TableActionType.SET_MODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        mode: action.payload
      }, action.payload === Mode.VIEW && {
        changes: {},
        data: getInitTableData(state.originalData),
        selection: {}
      });

    case TableActionType.UPDATE_CELL:
      {
        var _action$payload = action.payload,
            columnId = _action$payload.columnId,
            value = _action$payload.value,
            rowId = _action$payload.rowId;
        var originalValue = getCellValue(columnId, state.originalData[rowId]); // If value is same as original, remove from changes

        var newChanges = _objectSpread({}, state.changes);

        if (value === originalValue) {
          var _newChanges$rowId;

          (_newChanges$rowId = newChanges[rowId]) === null || _newChanges$rowId === void 0 ? true : delete _newChanges$rowId[columnId];

          if (R.isEmpty(newChanges[rowId])) {
            delete newChanges[rowId];
          }
        } else {
          newChanges[rowId] = _objectSpread(_objectSpread({}, newChanges[rowId]), {}, _defineProperty({}, columnId, value));
        } // Update data for display


        var newData = _toConsumableArray(state.data);

        newData[rowId] = R.assocPath(columnId.split('.'), value, newData[rowId]);
        return _objectSpread(_objectSpread({}, state), {}, {
          changes: newChanges,
          data: newData
        });
      }

    case TableActionType.BULK_UPDATE:
      {
        var _action$payload2 = action.payload,
            _columnId = _action$payload2.columnId,
            _value = _action$payload2.value,
            selectedRows = _action$payload2.selectedRows;

        var _newChanges = _objectSpread({}, state.changes);

        var _newData = _toConsumableArray(state.data);

        selectedRows.forEach(function (rowId) {
          var originalValue = getCellValue(_columnId, state.originalData[rowId]);

          if (_value === originalValue) {
            var _newChanges$rowId2;

            (_newChanges$rowId2 = _newChanges[rowId]) === null || _newChanges$rowId2 === void 0 ? true : delete _newChanges$rowId2[_columnId];

            if (R.isEmpty(_newChanges[rowId])) {
              delete _newChanges[rowId];
            }
          } else {
            _newChanges[rowId] = _objectSpread(_objectSpread({}, _newChanges[rowId]), {}, _defineProperty({}, _columnId, _value));
          }

          _newData[rowId] = R.assocPath(_columnId.split('.'), _value, _newData[rowId]);
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          changes: _newChanges,
          data: _newData
        });
      }

    case TableActionType.SET_SELECTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        selection: action.payload
      });

    case TableActionType.SET_COLUMN_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        columnFilters: action.payload
      });

    case TableActionType.SET_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        pagination: {
          pageIndex: action.payload,
          pageSize: state.pagination.pageSize
        }
      });

    case TableActionType.SET_SORTING:
      return _objectSpread(_objectSpread({}, state), {}, {
        sorting: action.payload
      });

    case TableActionType.RESET_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: getInitTableData(action.payload),
        originalData: action.payload
      });

    case TableActionType.ON_SAVING:
      return _objectSpread(_objectSpread({}, state), {}, {
        saving: true
      });

    case TableActionType.ON_SAVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        saving: false
      });

    case TableActionType.RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        mode: Mode.VIEW,
        data: getInitTableData(state.originalData),
        originalData: state.originalData,
        changes: {},
        selection: {},
        saving: false
      });

    default:
      return state;
  }
}